import http from 'common/http'
import {
  tenantUsersFetched,
  tenantUserCreated,
  tenantUserEdited,
  tenantUserDeleted,
} from 'actions/user-management'

export const fetchTenantUsers = () => {
  return (dispatch) => {
    return http.get('/users').then((res) => {
      dispatch(tenantUsersFetched(res.data))
    })
  }
}

export const createTenantUser = (data) => {
  return (dispatch) => {
    return http.post('/users', data).then((res) => {
      dispatch(tenantUserCreated(res.data))
    })
  }
}

export const editTenantUser = (userId, data) => {
  return (dispatch) => {
    return http.put(`/users/${userId}`, data).then((res) => {
      dispatch(tenantUserEdited(res.data))
    })
  }
}

export const deleteTenantUser = (userId) => {
  return (dispatch) => {
    return http.delete(`/users/${userId}`).then((res) => {
      dispatch(tenantUserDeleted(userId))
    })
  }
}
